module.exports = __webpack_public_path__ + "img/ic-products.8f9c9a92.png";